import React, { useState } from "react";
import toast from "react-hot-toast";
import { resetPassword } from "../../api/userRequest";
import "./changepassword.css";

function ResetPasswordPage() {
  const resetPasswordToken = window.location.pathname.split("/")[3];
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      const { data } = await resetPassword({
        password: newPassword,
        token: resetPasswordToken,
      });

      toast.success(data.message);
      localStorage.setItem("skilloptoken", data.token);
      window.location.replace("/homepage");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <main className="auth-layout">
      <form className="card" onSubmit={handlePasswordChange}>
        <h1 className="heading">Reset Password</h1>

        <div className="input-group">
          <label>New Password</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>

        <div className="input-group">
          <label>Confirm New Password</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="primary-btn">
          Change Password
        </button>
      </form>
    </main>
  );
}

export default ResetPasswordPage;
